import { AGE_CATEGORY } from './constant';

const getCategoriesFromAge = (age) => {
  const categories = [];
  for (const key in AGE_CATEGORY) {
    const category = AGE_CATEGORY[key];
    if (age >= category.minYear && age <= category.maxYear) {
      categories.push(category.name);
    }
  }
  if (categories.length === 0) {
    return ['N/A'];
  }
  return categories;
};

export const computeCategorie = (birthDate, season, level = undefined) => {
  if (!birthDate) {
    return { international: ['N/A'], national: ['N/A'] };
  }

  const birth = new Date(birthDate);

  // International category (based on current age)
  const today = new Date();
  let internationalAge = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    internationalAge--;
  }
  const internationalCategories = getCategoriesFromAge(internationalAge);

  // National category (based on age during the season)
  let nationalCategories = ['N/A'];
  if (season && season.startDate) {
    const seasonStartDate = new Date(season.startDate);
    // The category is determined by the age reached in the calendar year the season ends.
    const nationalAge = seasonStartDate.getFullYear() - birth.getFullYear();
    nationalCategories = getCategoriesFromAge(nationalAge);
  }

  if (level) return level === 'INTERNATIONAL' ? internationalCategories : nationalCategories;

  return {
    international: internationalCategories,
    national: nationalCategories,
  };
};

export const computeWeightBasedOnCategorie = (weight, gender, category) => {
  if (!category || !gender || !weight) {
    return undefined;
  }
  const objCategorie = Object.values(AGE_CATEGORY).find((c) => c.name === category);
  if (!objCategorie) {
    return undefined;
  }
  const weights = objCategorie.weights[gender.toLowerCase()];
  if (!weights) {
    return undefined;
  }
  const foundWeight = weights.find((w) => weight < w);
  return foundWeight === undefined ? `+${weights[weights.length - 1]}` : `-${foundWeight}`;
};

export const computeAge = (birthDate) => Math.floor(
  (new Date() - new Date(birthDate).getTime()) / 3.15576e+10,
);

export const fileSizeInBytes = (base64) => {
  const base64String = base64.replaceAll('=', '');
  const bytes = base64String.length * (3 / 4);

  return bytes;
};

export const readableFileSize = (attachmentSize) => {
  const DEFAULT_SIZE = 0;
  const fileSize = attachmentSize ?? DEFAULT_SIZE;

  if (!fileSize) {
    return `${DEFAULT_SIZE} kb`;
  }

  const sizeInKb = fileSize / 1024;

  if (sizeInKb > 1024) {
    return `${(sizeInKb / 1024).toFixed(2)} mb`;
  }
  return `${sizeInKb.toFixed(2)} kb`;
};

export const getFileType = (base64file) => base64file.split(';')[0].split(':')[1];

export const formatDate = (date) => {
  const d = new Date(date);
  return d.toLocaleDateString();
};
